import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { SetWalletSetupModals } from "@/constants/enums";
import { Dispatch, SetStateAction } from "react";
import myronLogo from "@/assets/MYRON-icon-transparent.webp";
import { useTranslation } from "react-i18next";
import { toNormalCase } from "@/utils/helpers";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/opacity.css";
import { FramerButton } from "@/components/shared";

type Props = {
  showModal: SetWalletSetupModals;
  setShowModal: Dispatch<SetStateAction<SetWalletSetupModals>>;
  username: string;
}

function SetWalletWelcomeModal({ showModal, setShowModal, username }: Props) {
  const { t } = useTranslation(["modals"]);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setShowModal(SetWalletSetupModals.NoModal);
    }
  };

  return (
    <Dialog open={showModal === SetWalletSetupModals.Welcome} onOpenChange={handleOpenChange}>
      <DialogContent className="px-6 max-w-3xl max-h-[90vh] overflow-y-auto dark:bg-mfdarklight"
        onPointerDownOutside={(event) => {
          event.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="sr-only">
            Set Wallet Public Key
          </DialogTitle>
        </DialogHeader>

        {/* Image container */}
        <div className="flex justify-center mb-8 py-8">
          <LazyLoadImage
            alt={"Myron logo"}
            className="h-16"
            src={myronLogo}
            effect="opacity"
          />
        </div>

        {/* Content container */}
        <div className="mb-4">
          <h1 className="font-bold text-xl mb-4 dark:text-white">{t("initialisepublickey.welcome.title")}&nbsp;
            <span className="text-mforange">{t("initialisepublickey.welcome.myron")}</span>, {toNormalCase(username)}!
          </h1>
          <p className="dark:text-gray-100">
            {t("initialisepublickey.welcome.text")}
          </p>
        </div>

        {/* Buttons container */}
        <div className="flex justify-end">
          <FramerButton
            onClick={() => setShowModal(SetWalletSetupModals.Setup)}
            className="bg-mforange text-white hover:bg-mforange/80"
          >
            {t("common:buttons.getstarted")}
          </FramerButton>
        </div>

        {/* Stepper */}
        <div className="flex justify-center mt-8">
          <div className="flex items-center">
            <div className="h-2 w-2 bg-mforange rounded-full" />
            <div className="h-2 w-2 bg-gray-300 rounded-full mx-2" />
            <div className="h-2 w-2 bg-gray-300 rounded-full" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SetWalletWelcomeModal;
